export type AiConfig = {
	apiKey: string;
	model: string;
};

export type AppSettings = {
	assistant: AiConfig;
	ocr: AiConfig;
};

export const DEFAULT_AI_CONFIG: AiConfig = {
	apiKey: '',
	model: '',
};

export const DEFAULT_APP_SETTINGS: AppSettings = {
	assistant: {...DEFAULT_AI_CONFIG},
	ocr: {...DEFAULT_AI_CONFIG},
};
